/**
 * Light or dark: the system's choice unless the person picked one. The
 * choice is a per-browser convenience, kept in localStorage.
 */

export type ThemeChoice = 'system' | 'light' | 'dark';
const KEY = 'finokay.theme';

export function themeChoice(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch {
    return 'system';
  }
}

function prefersDark(): boolean {
  return typeof matchMedia !== 'undefined' && matchMedia('(prefers-color-scheme: dark)').matches;
}

export function applyTheme(choice: ThemeChoice = themeChoice()): void {
  if (typeof document === 'undefined') return;
  const dark = choice === 'dark' || (choice === 'system' && prefersDark());
  document.documentElement.classList.toggle('dark', dark);
}

export function setThemeChoice(choice: ThemeChoice): void {
  try {
    if (choice === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, choice);
  } catch {
    // Private mode: the choice lasts for this page only.
  }
  applyTheme(choice);
}

if (typeof window !== 'undefined') {
  applyTheme();
  matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    if (themeChoice() === 'system') applyTheme('system');
  });
}
